import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

export const DOC = gql`
  ${fragments.functionalUsage.DOC}
  mutation UpdateSpaceRecordFunctionalUsage(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $spaceRecordId: ID!
    $update: SpaceRecordFunctionalUsageUpdate!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                updateSpaceRecordFunctionalUsage(
                  spaceRecordId: $spaceRecordId
                  update: $update
                ) {
                  ...FragmentSpaceRecordFunctionalUsage
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.UpdateSpaceRecordFunctionalUsageMutation,
    ents.extra.space.Record.FunctionalUsage | undefined,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'updateSpaceRecordFunctionalUsage',
                fragments.functionalUsage.TRANSFORMER,
              ),
            ),
          ),
        ),
      ),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.UpdateSpaceRecordFunctionalUsageMutation,
  ents.extra.space.Record.FunctionalUsage | undefined,
  graphql.schema.UpdateSpaceRecordFunctionalUsageMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
